module.exports = __webpack_public_path__ + "static/media/feedback.d8733cb4.svg";